import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@ontruck/orc';

const PDFItem = ({ onDelete, file }) => {
  const type = file && file.type;
  const typeSplited = type && type.split('/');
  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete(file);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(file && file.url, '_blank');
  };
  return (
    <div className="file-item" onClick={handleClick}>
      <span className="delete-item-button" onClick={handleDelete}>
        <Icon glyph="close" className="delete-item-icon" />
      </span>
      <span className="type-containter">
        {typeSplited && typeSplited[1] && (typeSplited[1] || '').toUpperCase()}
      </span>
      <span className="item-name">{file && file.name}</span>
    </div>
  );
};

PDFItem.propTypes = {
  onDelete: PropTypes.func,
  file: PropTypes.shape({ type: PropTypes.string }),
};

PDFItem.defaultProps = {
  onDelete: () => ({}),
  file: '',
};

export default PDFItem;
